import React from "react";
import { Link } from "react-router-dom";
const Product = ({ product }) => {
  // Check if image exists safely
  const imageUrl = product?.image?.url;

  return (
    <Link to={`/product/${product.id}`}>
      <div className="grad w-full h-[362px] rounded-[8px] overflow-hidden relative group">
        {/* badge */}
        {product.isNew ? (
          <div className="absolute bg-[#f24a04] text-primary text-[12px] font-extrabold uppercase top-4 right-4 px-2 rounded-full z-10">
            New
          </div>
        ) : (
          ""
        )}

        {/* image */}
        <div className="w-full h-[200px] flex items-center justify-center">
          {imageUrl ? (
            <img
              className="w-[160px] h-[160px] group-hover:scale-90 transition-all"
              src={`https://cms.sapnafashions.com${imageUrl}`}
              alt="Product"
            />
          ) : (
            <p>No image available</p> // fallback if no image
          )}
        </div>
        {/* text */}
        <div className="px-6 pb-8 flex flex-col">
          {/* category title */}
          {/* Categories */}
          <div className="text-sm text-[#f24a04] capitalize mb-2">
            {product.categories && product.categories.length > 0 ? (
              product.categories.map((category) => (
                <span key={category.id}>{category.title}</span>
              ))
            ) : (
              <p>No category assigned</p>
            )}
          </div>
          {/* title */}
          <div className="text-[15px] mb-4 lg:mb-9">
            {product.title.substring(0, 35)}...
          </div>
          {/* price */}
          <div className="text-lg text-[#f24a04]">${product.price}</div>
        </div>
      </div>
    </Link>
  );
};

export default Product;
